import moment from 'moment'
import { logout } from './auth'

export function isAccountManager() {
    return process.env.VUE_APP_REPORTING_DATE === 'true'
}

export async function create(viewModel) {
    if (viewModel.$route.name === 'Reporting') {
        viewModel.current = viewModel.policies[viewModel.policies.length - 1]

        if (shouldNotReport(viewModel)) {
            await viewModel.$router.push({ name: 'Reported' })
        }

    } else if (viewModel.$route.name === 'Reported') {
        viewModel.policy = viewModel.policies[viewModel.policies.length - 1]

    } else if (viewModel.$route.name === 'Confirmation') {
        if (alreadyReported(viewModel)) {
            await viewModel.$router.push({ name: 'Reported' })
        }
    }
}

function shouldNotReport(viewModel) {
    return (isOutsideReportingPeriod(viewModel.reporting) && !isAccountManager()) || viewModel.contact.hasReported || hasNoPoliciesToReport(viewModel.policies)
}

function isOutsideReportingPeriod(reporting) {
    let reportingDate = moment(reporting.date)
    return reportingDate.isBefore(reporting.startDate) || reportingDate.isAfter(reporting.endDate);
}

function hasNoPoliciesToReport(policies) {
    const policiesToReport = policies.filter(policy => !policy.hasReportedPayroll)
    return policiesToReport.length <= 0
}

function alreadyReported(viewModel) {
    return viewModel.submittedPayroll.length < 1 && viewModel.contact.hasReported
}

export function reportingPeriod(reportingDate) {
    let today = moment(reportingDate)
    if (today.date() >= 20) {
        return today.format('MMMM YYYY')
    } else {
        return today.subtract(1, 'month').format('MMMM YYYY')
    }
}

export function startPeriod(policy, reportingDate) {
    let polEffDate = moment(policy.effectiveDate)
    let today = moment(reportingDate)
    let firstOfMonth
    if (today.date() >= 20) {
        firstOfMonth = today.startOf('month')
    } else {
        firstOfMonth = today.subtract(1, 'month').startOf('month')
    }
    return moment.max(polEffDate, firstOfMonth).format('MM/DD/YYYY')
}

export function endPeriod(policy, reportingDate) {
    let today = moment(reportingDate)
    let polExpDate = moment(policy.expirationDate).subtract(1, 'days')
    let polCancelDate = policy.cancellationDate === null ? moment({ year: 2099, month: 11, day: 30 }) : moment(policy.cancellationDate).subtract(1, 'days')
    let lastOfMonth
    if (today.date() >= 20) {
        lastOfMonth = today.endOf('month')
    } else {
        lastOfMonth = today.subtract(1, 'month').endOf('month')
    }
    return moment.min(polExpDate, polCancelDate, lastOfMonth).format('MM/DD/YYYY')
}

export function onLogout(viewModel) {
    logout()
    viewModel.$store.dispatch('reset').then(() => {
        viewModel.$router.push({ name: 'Login' })
    })
}
